// eslint-disable-next-line spaced-comment
/// <reference types="../../../src/liburi" />
// TODO: These triple slash directives are not very idiomatic. We should make the liburi definition file into a real re-exporting module and just use that instead.
import * as URI from 'spotify-liburi';
import { ManifestFormat } from '../../enums/manifest_format';
const HTTPS_EXP = /^https:\/\//;
const FILE_ID_EXP = /^(.+?)\/([^./]+)(\.[^/]*)?$/;
const _containerFormat = {
    [ManifestFormat.FILE_URLS_MP3]: 'MP3',
    [ManifestFormat.FILE_URLS_EXTERNAL]: 'MP3',
    [ManifestFormat.FILE_IDS_MP4]: 'MP4',
    [ManifestFormat.FILE_IDS_MP4_DUAL]: 'MP4',
    [ManifestFormat.FILE_IDS_CBCS]: 'MP4_CBCS',
    [ManifestFormat.MANIFEST_IDS_VIDEO]: 'MANIFEST',
};
/**
 * Resolves a playable manifest from a file.
 *
 * @param manifestFormats - An array of manifest formats,
 *     supported, ordered in preference.
 * @param item - The track.
 * @param options - Options for manifest resolution.
 * @return The resolved file, or null if it cannot be resolved.
 */
export function resolveManifestFile(manifestFormats, item) {
    const manifest = item.manifest;
    const uri = item.metadata.uri;
    const uriObj = URI.from(uri);
    const isAd = !!(uriObj &&
        (uriObj.type === URI.Type.AD || uriObj.type === URI.Type.INTERRUPTION));
    for (let i = 0, l = manifestFormats.length; i < l; i++) {
        const format = manifestFormats[i];
        if (!(format in manifest)) {
            continue;
        }
        const files = manifest[format];
        if (!files.length) {
            continue;
        }
        const file = files[0];
        if (!file.file_id && !file.file_url) {
            continue;
        }
        let fileURL = file.file_url;
        let fileId = file.file_id || '';
        // Special case: ads are delivered with a file_url, but we do not want to
        // play directly from that URL. Instead, we want to resolve the ad file id
        // through Storage Resolve, so we extract the ad id from the URL and use
        // that as the file id.
        if (fileURL && format === ManifestFormat.FILE_URLS_MP3 && isAd) {
            fileId = fileURL.replace(FILE_ID_EXP, '$2');
            if (fileId === fileURL) {
                // The URL is not what we expected, so we can't use this file.
                continue;
            }
            // We set the fileURL to null so we are forced to play the fileId.
            fileURL = undefined;
        }
        if (fileURL && !HTTPS_EXP.test(fileURL)) {
            // This file URL is invalid. We null it so it can't be used.
            fileURL = undefined;
        }
        if (!fileId && !fileURL) {
            // Nothing can be played from this file.
            continue;
        }
        let mediaType;
        if (file.track_type) {
            mediaType = file.track_type.toLowerCase();
        }
        else {
            // Guess via the manifest format.
            mediaType =
                format === ManifestFormat.MANIFEST_IDS_VIDEO ? 'video' : 'audio';
        }
        return {
            uri: uri,
            uriType: uriObj && uriObj.type ? uriObj.type : undefined,
            fileId: fileId,
            resolvedURL: fileURL,
            mediaType: mediaType,
            format: _containerFormat[format],
            bitrate: file.bitrate || 128000,
            impressionURL: file.impression_url,
            impressionURLs: file.impression_urls,
            isAd: isAd,
            noLog: false,
            noTSV: isAd,
            noStats: isAd,
            noManifest: !!file.file_url,
            playable: true,
        };
    }
    return null;
}
//# sourceMappingURL=resolve_manifest_file.js.map